<template>
  <div
    class="jade-icon-shape"
    :class="computedClass"
  >
    <jade-icon
      :use="use"
      :size="computedSize"
      color="current-color"
    ></jade-icon>
  </div>
</template>

<script>
import COLOR_ENUM from '../enums/colors.enum'
import SIZE_ENUM from '../enums/sizes.enum'

import { JadeIcon } from '../'

export default {
  name: 'JadeIconShape',

  components: {
    JadeIcon
  },

  props: {
    use: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: SIZE_ENUM.MEDIUM,
      validation: size =>
        [SIZE_ENUM.LARGE, SIZE_ENUM.MEDIUM, SIZE_ENUM.SMALL].includes(size)
    },
    variant: {
      type: String,
      default: COLOR_ENUM.POSITIVE,
      validation: color =>
        [
          COLOR_ENUM.NEGATIVE,
          COLOR_ENUM.WARNING,
          COLOR_ENUM.POSITIVE,
          COLOR_ENUM.INFO,
          COLOR_ENUM.BRAND,
          COLOR_ENUM.NEUTRAL
        ].includes(color)
    }
  },

  computed: {
    computedClass () {
      return {
        [`is-${this.size}`]: this.size,
        [`is-${this.variant}`]: this.variant
      }
    },
    computedSize () {
      const size = {
        [SIZE_ENUM.MEDIUM]: SIZE_ENUM.LARGE,
        [SIZE_ENUM.SMALL]: SIZE_ENUM.MEDIUM,
        [SIZE_ENUM.LARGE]: SIZE_ENUM.XLARGE
      }
      return size[this.size]
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/icon-shape.css';
</style>
